import React from 'react';

export const ImagesContext = React.createContext();
export const ImagesProvider = ImagesContext.Provider;
